import { GridColumns } from '@mui/x-data-grid';
import { format } from 'date-fns';
import {
    createUseSearchService,
    ISearchConfiguration,
    ISearchRequest,
    ISearchResponse,
    ISearchService,
} from '../../reusableFeatures';
import { backendServices, orderBy, portalUserService } from '../../services';
import { BusinessDocType } from '../../types';
import { paginate } from '../../utils';

export class QuestionnaireSearchService implements ISearchService<backendServices.ViewModels.BusinessDocTypeViewModel> {
    private businessDocTypeApi = new backendServices.Apis.BusinessDocTypeApi();

    async fetchSearchConfiguration(): Promise<
        ISearchConfiguration<backendServices.ViewModels.BusinessDocTypeViewModel>
    > {
        const gridColumns: GridColumns = [
            {
                headerName: 'Name',
                field: 'Name',
                flex: 1,
            },
            {
                headerName: 'Description',
                field: 'Description',
                flex: 1,
            },
            {
                headerName: 'Active',
                field: 'Active',
                flex: 1,
                sortable: false,
                renderCell: (params) => (params.value ? 'Yes' : 'No'),
            },
            {
                headerName: 'Last Updated',
                field: 'LastUpdateDate',
                flex: 1,
                renderCell: (params) => format(new Date(params.value), 'P'),
            },
        ];

        return {
            gridColumns,
            pageSizeOptions: [10, 25, 50],
            defaultPageSize: 10,
        };
    }

    async fetchResults(
        _searchConfiguration: ISearchConfiguration<backendServices.ViewModels.BusinessDocTypeViewModel>,
        searchRequest: ISearchRequest<backendServices.ViewModels.BusinessDocTypeViewModel>
    ): Promise<ISearchResponse> {
        const currentCompanyId = portalUserService.getCurrentCompanyId();

        const { data } = await this.businessDocTypeApi.getBusinessDocType({
            $filter: `BusinessDocTypeId eq ${BusinessDocType.SIMDocument} and CompanyId eq ${currentCompanyId}`,
            $orderBy: orderBy(searchRequest.sort),
        });

        return {
            pageResults: paginate(data, searchRequest.pageSize, searchRequest.pageNumber),
            totalResultCount: data.length,
        };
    }

    exportData(): Promise<void> {
        throw new Error('Exporting not implemented for questionnaire search');
    }

    get key(): string {
        return 'QuestionnaireSearch';
    }
}

export const useQuestionnaireSearchService = createUseSearchService(QuestionnaireSearchService);
